import * as React from "react";
import { useParams, useHistory } from "react-router-dom";
import differenceBy from "lodash-es/differenceBy";
import { FixedCommentSetForm } from "../FixedCommentsForm/FixedCommentsForm";
import { FixedCommentSetFormModel, GetModelFromFormState, GetFormStateFromModel, GetSetFormStateFromModel } from "../Types";
import { AuditModal, AuditForm } from "../../../auditmodal/components/AuditModal";
import { StudyFixedCommentSet, WebPortalClient } from "webportalclient";
import { useCurrentStudyConfigurationContext } from "../../../Core/CurrentStudyConfigurationContext";
import { useWebPortalApiClient } from "../../../misc/api/WebPortalTokenClient";

const EditFixedCommentSetScreen = ({ }): JSX.Element => {

    const { id } = useParams<{ id: string }>();
    const [isBusy, setIsBusy] = React.useState<boolean>(false);
    const [error, setError] = React.useState<string>();
    const [initialState, setInitialState] = React.useState<FixedCommentSetFormModel>();
    const [showAuditModal, setShowAuditModal] = React.useState<boolean>(false);
    const [formToSubmit, setFormToSubmit] = React.useState<StudyFixedCommentSet>();
    const client = useWebPortalApiClient();

    const history = useHistory();
    const { study } = useCurrentStudyConfigurationContext();

    const onSubmit = (values: FixedCommentSetFormModel) => {

        setFormToSubmit(GetModelFromFormState({
            ...values,
            Id: id
        }, study.id));
        setShowAuditModal(true);
    };

    React.useEffect(() => {

        const getFormState = async () => {
            setIsBusy(true);

            try {
                const set = await client.client.getFixedCommentSet(id, undefined, "comments,studySet");
                setInitialState(GetSetFormStateFromModel(set));
            } catch (e) {
                setError(e.message);
            } finally {
                setIsBusy(false);
            }
        };

        getFormState();
    }, [id]);


    const handleSubmit = async (values: AuditForm) => {
        setIsBusy(true);
        setError(null);
        try {
            const fixedComments = await client.client.getFixedComments(undefined, `setId eq ${formToSubmit.id}`);
            const toDelete = differenceBy(fixedComments.value, formToSubmit.fixedCommentSets[0].comments, c => c.id);

            for (const deleteComment of toDelete) {
                await client.client.deleteFixedComment(deleteComment.id);
            }

            for (const comment of formToSubmit.fixedCommentSets[0].comments) {
                if (fixedComments.value.map(fc => fc.id).includes(comment.id)) {
                    await client.client.patchFixedComment(comment, comment.id, "");
                } else {
                    await client.client.postFixedComment({ ...comment, setId: formToSubmit.id });
                }               
            }

            await client.client.patchFixedCommentSet({ entityType: formToSubmit.fixedCommentSets[0].entityType }, formToSubmit.id, "");

            setShowAuditModal(false);
            setIsBusy(false);
            history.push("/FixedComments");
        } catch (e) {
            setError(e.message);
            setShowAuditModal(false);
            setIsBusy(false);
        }
    };


    return (!!initialState ? <>
        <FixedCommentSetForm editMode={true} title="Edit Fixed Comment Set" initalCommentsFormValues={initialState} onSubmit={onSubmit} error={error} />
        {showAuditModal ? <AuditModal onSubmit={handleSubmit} onClose={() => setShowAuditModal(false)} isSubmitting={isBusy} header="Edit Fixed Comments" /> : null}
        </> : null);
};

export default EditFixedCommentSetScreen;
